// Centralized state — single source of truth for all tabs.
// Mutations go through set(); reactive consumers subscribe with on().

export interface Ticker {
  Ticker: string;
  Company?: string;
  Sector?: string;
  EntryPrice?: string;
  Shares?: string;
  Exchange?: string;
  Notes?: string;
  _id?: string | number;
}

export interface ScannerResult {
  scannedAt: string;
  count: number;
  matches: any[];
  criteria?: Record<string, number>;
  note?: string;
}

export interface BriefData {
  date: string;
  brief: string;
  generatedAt: string;
}

export interface AppState {
  activeTab: string;
  tickers: Ticker[];
  ipoData: any[];
  roadmapData: any[];
  scannerData: ScannerResult | null;
  briefData: BriefData | null;
}

type Listener<T> = (value: T) => void;
type Unsubscribe = () => void;

class Store {
  private s: AppState;
  private listeners = new Map<string, Set<Listener<any>>>();

  constructor(initial: AppState) {
    this.s = { ...initial };
  }

  get<K extends keyof AppState>(key: K): AppState[K] {
    return this.s[key];
  }

  set<K extends keyof AppState>(key: K, value: AppState[K]): void {
    this.s[key] = value;
    this.listeners.get(key as string)?.forEach(fn => fn(value));
  }

  on<K extends keyof AppState>(key: K, fn: Listener<AppState[K]>): Unsubscribe {
    const k = key as string;
    if (!this.listeners.has(k)) this.listeners.set(k, new Set());
    this.listeners.get(k)!.add(fn);
    return () => this.listeners.get(k)?.delete(fn);
  }
}

export const store = new Store({
  activeTab:   'tracker',
  tickers:     [],
  ipoData:     [],
  roadmapData: [],
  scannerData: null,
  briefData:   null,
});
